export default __webpack_public_path__ + "static/media/ledger.7a656384.svg";